// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "8729b11c7208";
export const BUILD_VERSION_NUMBER = 96;
